module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"number":"Nummer","state":"Status","createdAt":"Erstellt am","createdBy":"Erstellt von","modifiedAt":"Geändert am","modifiedBy":"Geändert von"},"en":{"number":"Number","state":"State","createdAt":"Created at","createdBy":"Created by","modifiedAt":"Modified at","modifiedBy":"Modified by"}}')
  delete Component.options._Ctor
}
